import React from 'react'
import { colors } from '@mobi/component-library/Theme/Common'
import { BannerContainerStyled, BannerContentStyled } from './OffersBanner.styles'
import { OfferIcon } from './OfferIcon'
import { VENUE_FEATURE_NAME_SINGULAR } from '@core/Areas/VenueMode/constants'

const VenueIconBgPattern = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 401 40' fill='none' aria-hidden='true'>
    <rect
      width='460.493'
      height='123'
      transform='translate(0 -4.55469) rotate(-9.75347)'
      fill='url(#venueIconPattern)'
      fillOpacity='0.1'
    />
    <rect
      width='460.493'
      height='123'
      transform='translate(0 -4.55469) rotate(-9.75347)'
      fill='url(#venueLinearGradient)'
    />
    <defs>
      <linearGradient
        id='venueLinearGradient'
        x1='55.898'
        y1='50.3931'
        x2='435.025'
        y2='41.4952'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor={colors.warning[700]} />
        <stop offset='1' stopColor={colors.warning[700]} stopOpacity='0' />
      </linearGradient>
      <pattern id='venueIconPattern' patternUnits='userSpaceOnUse' width='20' height='20'>
        <OfferIcon outerColor={colors.white} innerColor={colors.warning[700]} />
      </pattern>
    </defs>
  </svg>
)

export const OffersBanner = () => (
  <BannerContainerStyled>
    <VenueIconBgPattern />
    <BannerContentStyled>
      <OfferIcon outerColor={colors.white} innerColor={colors.warning[700]} />
      {`${VENUE_FEATURE_NAME_SINGULAR} Offers`}
    </BannerContentStyled>
  </BannerContainerStyled>
)
